import type { Dispatch } from 'redux';
import { performNativeAction } from '../utils/nativeBridge';
import { resolveThemeTokens } from './themeTokens';
import { setThemeTokens } from './uiThemeReducer';

// Fetch the app's theme tokens from the native bridge and apply them via dispatch.
export const fetchAndApplyTheme = async (dispatch: Dispatch): Promise<void> => {
  const res = await performNativeAction<Record<string, unknown> | string>(
    'ui.get',
    { type: 'themeColors' },
  );
  if (res == null) return;
  const themeTokens = resolveThemeTokens(res);
  if (Object.keys(themeTokens).length > 0) {
    dispatch(setThemeTokens(themeTokens));
    // Drive antd-mobile's primary token so every `<... color="primary">` themes too
    if (themeTokens.primaryColor) {
      document.documentElement.style.setProperty('--adm-color-primary', themeTokens.primaryColor);
    }
  }
};
